export default "__VITE_ASSET__BOPBa38i__"